//react
import React, { useState } from "react";
import { useParams } from "react-router-dom";

//material UI
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  RadioGroup,
  TextField,
} from "@mui/material";
import Dropdown from "../../Dropdown";

//react redux
import { useDispatch, useSelector } from "react-redux";

//slices
import {
  setConfidenceLevel,
  setIsLoading,
} from "../../../features/datatable/dataTableSlice";

//functions
import {
  createAnalysis,
  getHeaders,
} from "../../../utils/computation/analysis";
import { getColumnValues } from "../../../utils/computation/getColumnValues";
import { getScatterPlot } from "../../../utils/computation/getScatterPlot";
import { getCorrelation } from "../../../utils/computation/getCorrelation";
import FunctionButtons from "../modules/FunctionButtons";
import { checkArrayLengths } from "../../../utils/functions/checkArrayLength";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  p: 4,
  borderRadius: "15px",
};

const CorrelationModal = ({ title, closeMenu, openModal, setOpenModal }) => {
  //local states
  const [Methods, setMethods] = useState({
    isPearson: false,
    isSpearman: false,
    isKendall: false,
  });
  const [error, setError] = useState(false);
  const [First, setFirst] = useState("");
  const [Second, setSecond] = useState("");
  const [graphs, setgraphs] = useState({
    isScatterplot: false,
  });

  //dispatch
  const dispatch = useDispatch();

  //params
  const { documentId } = useParams();

  //redux states
  const { token } = useSelector((state) => state.auth);
  const { data } = useSelector((state) => state.dataTable);

  //functions
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const onChangeFirstColumn = (e) => {
    setFirst(e.target.value);
  };
  const onChangeSecondColumn = (e) => {
    setSecond(e.target.value);
  };
  const handleGraphCBChange = (event) => {
    setgraphs({
      ...graphs,
      [event.target.name]: event.target.checked,
    });
  };
  const handleMethodsChange = (event) => {
    setMethods({ ...Methods, [event.target.name]: event.target.checked });
  };
  const handleChangeConfidenceLevel = (value) => {
    dispatch(setConfidenceLevel(value));
  };

  const computeTTest = async () => {
    dispatch(setIsLoading());
    // get the array value of selected column
    const firstValue = getColumnValues(data, First);
    const secondValue = getColumnValues(data, Second);
    const XHeader = getHeaders(data, First);
    const YHeader = getHeaders(data, Second);

    const arrayData = [
      { title: XHeader[0], array: firstValue },
      { title: YHeader[0], array: secondValue },
    ];
    const res = checkArrayLengths(arrayData);

    const haveSameLength = res.isSuccess;
    haveSameLength ? setError(false) : setError(res.message);
    haveSameLength && closeMenu();

    if (firstValue.length > 0 && secondValue.length > 0 && haveSameLength) {
      let corResult = {};
      let scatterPlotResult = {};

      if (title === "Simple Correlation") {
        //compute t result using API
        [corResult, scatterPlotResult] = await Promise.all([
          getCorrelation({
            arr1: firstValue,
            arr2: secondValue,
          }),
          graphs.isScatterplot &&
            getScatterPlot({
              arr1: firstValue,
              arr2: secondValue,
              withReg: false,
            }),
        ]);
      } else {
        [corResult] = await Promise.all([
          // getMultipleCorrelation({
          //   // "title": ["A","B","C","D","E","F","G"],
          //   // "arr": [
          //   //     [68,63,71,82,79,92,82,83,65,55,69,78,99,59,71,66,90,54,100,92,76,93,93,90,74,59,61,56,70,92,78,98,68,71,68,94,97,63,79,56,87,50,74,54,62,58,72,63,84,73,80,67,86,80,74,55,77,52,89,57,57,68,93,54,53,99,77,83,53,93,62,73,88,87,90,82,83,60,88,77,84,97,78,82,50,80,66,84,66,76,75,55,72,99,82,77,99,85,99,60,86,78,62,61,85,65,66,88,67,96,68,50,50,51,60,90,76,81,87,77,75,64,75,88,70,63,89,94,54,85,80,84,81,57,77,74,66,88,61,69,75,65,65,62,55,64,87,56,70,75,71,51,71,80,87,57,89,74,63,57,79,60,64,66,67,98,78,75,80,51,77,54,73,98,86,50,60,89,84,87,54,76,84,92,89,91,83,69,67,99,97,68,100,88,52,84,87,80,63,89,74,78,70,62,70,92,53,54,96,76,67,97,73,71,75,59,78,54,60,100,80,55,84,93,57,78,54,85,92,72,56,58,71,56,58,54,95,77,95,53,74,72,90,98,63,52,54,54,81],
          //   //     [51,84,73,88,92,90,87,62,96,69,53,69,100,66,55,96,50,98,79,50,92,72,52,68,88,97,56,75,58,52,63,77,67,84,85,100,53,99,77,98,84,73,75,88,64,80,96,96,80,98,63,95,62,84,82,61,73,58,78,73,64,96,83,68,69,96,61,99,94,86,92,55,94,94,89,62,53,75,81,81,91,74,100,71,86,55,89,94,80,82,92,96,79,75,82,72,79,81,81,70,56,74,59,52,89,80,76,55,54,69,92,87,99,86,73,71,77,71,93,50,100,68,58,93,79,90,66,66,81,66,52,60,90,94,72,59,96,96,61,59,80,99,69,52,90,61,88,74,91,54,51,84,65,64,58,62,63,81,56,100,55,93,83,50,67,74,81,85,61,76,97,55,88,60,79,51,53,94,62,74,57,55,88,57,52,67,64,63,75,66,52,64,83,64,70,51,86,61,83,100,79,76,56,80,65,80,92,56,54,52,100,90,54,68,86,54,82,67,58,85,82,100,74,83,55,57,93,58,96,57,56,67,73,70,84,81,55,66,50,55,93,70,60,69,63,64,63,86,81],
          //   //     [71,96,58,93,66,61,89,91,60,71,55,96,99,85,87,85,99,76,57,93,99,97,60,95,71,58,64,72,86,67,52,86,74,90,92,85,76,98,78,67,99,76,59,69,100,79,69,80,54,64,58,61,97,92,78,82,74,79,68,91,68,53,64,65,86,64,54,75,57,68,70,53,95,67,83,90,95,78,63,68,85,53,94,79,80,65,54,62,100,92,59,97,88,50,65,51,53,60,62,68,87,89,96,62,65,87,94,51,61,88,87,65,72,96,100,56,82,83,98,54,60,55,72,96,72,55,67,71,80,98,94,88,60,62,73,66,63,100,92,60,85,68,66,98,80,52,65,73,81,52,76,85,61,64,85,92,76,70,88,54,56,86,78,79,98,60,81,72,93,70,66,72,63,83,83,73,96,73,55,100,71,58,67,68,69,86,71,77,55,81,99,85,88,69,93,67,56,67,96,100,72,97,59,59,100,80,96,92,77,74,73,50,76,88,72,92,79,51,81,83,75,74,82,95,82,64,82,86,70,93,54,58,93,93,54,58,71,52,67,89,87,96,58,93,69,82,81,87,52],
          //   //     [60,57,75,95,85,52,88,51,95,67,84,57,96,83,54,63,61,59,63,84,84,69,97,71,93,72,95,61,71,83,98,85,86,88,83,97,96,58,70,73,100,67,67,70,74,79,92,68,60,71,53,83,57,64,57,76,86,85,90,66,52,100,64,65,63,62,50,73,90,63,68,85,79,50,99,85,88,59,51,93,66,69,93,89,87,69,51,66,50,95,89,87,94,56,75,70,100,83,51,51,91,92,81,83,76,72,69,96,66,56,50,81,78,84,80,87,79,70,64,93,58,77,67,73,76,62,73,78,65,63,54,79,85,54,97,70,73,74,65,86,75,69,80,51,75,96,57,90,55,75,75,64,60,79,95,81,56,98,55,92,91,97,77,76,61,85,89,60,82,66,51,55,80,90,89,61,80,89,50,99,94,57,79,59,58,83,67,92,50,81,84,88,73,83,64,59,74,68,86,75,75,58,86,52,51,91,91,52,67,59,52,76,98,95,61,50,61,96,86,70,58,53,73,75,98,58,70,75,65,52,62,76,62,91,91,67,73,71,93,55,92,81,63,52,75,54,86,65,61],
          //   //     [92,52,95,79,65,97,54,65,53,52,65,95,73,84,86,50,67,64,83,90,57,62,61,81,79,80,53,75,60,68,71,78,66,81,51,66,77,81,67,74,66,71,65,55,69,50,71,76,67,70,84,94,57,76,99,72,62,71,63,52,100,50,63,77,60,100,61,92,87,60,61,68,78,99,99,88,61,71,91,90,99,66,68,89,99,98,82,95,61,65,73,76,62,94,81,73,56,90,50,61,55,81,82,96,80,54,53,59,84,88,84,90,63,82,99,79,50,67,51,85,80,74,53,63,50,95,52,52,84,79,89,53,76,63,78,76,93,65,77,56,88,88,98,78,79,53,99,90,61,70,74,78,100,97,76,57,86,63,68,82,83,96,69,51,69,58,84,82,52,71,56,69,72,59,85,84,63,65,85,64,70,85,66,88,85,59,80,93,79,65,74,80,61,89,100,62,50,79,57,64,53,99,53,52,80,96,75,97,51,86,86,55,97,72,67,55,80,61,96,82,64,86,95,68,78,82,65,97,67,50,89,54,63,91,52,78,76,63,74,86,74,83,98,85,91,84,97,77,84],
          //   //     [73,64,70,72,93,97,93,76,50,64,79,72,62,69,93,74,85,95,93,86,69,89,84,83,70,69,95,99,56,65,53,95,50,69,84,68,61,88,71,67,93,79,89,56,96,93,56,72,65,58,67,53,73,78,58,69,63,93,75,100,100,84,84,57,97,57,92,100,63,80,91,62,89,55,53,80,72,79,78,95,77,66,73,57,53,54,62,90,88,57,51,68,62,98,70,78,54,88,81,65,60,73,60,65,77,70,52,80,92,55,84,65,62,77,61,96,80,74,72,85,60,93,65,81,80,68,70,66,92,81,99,84,81,66,76,63,65,93,90,73,69,93,68,92,50,94,84,92,88,66,50,80,57,90,85,64,56,55,71,74,56,61,98,64,59,77,76,72,53,87,74,88,65,57,92,86,82,59,99,76,62,70,50,95,98,53,59,95,64,94,50,78,100,72,80,68,62,85,94,50,97,63,84,58,75,52,52,92,93,96,69,70,96,61,100,71,97,62,94,99,64,92,95,95,81,53,92,90,68,71,56,84,83,53,59,56,62,100,84,77,65,68,73,94,67,82,80,98,89],
          //   //     [60,53,100,76,83,69,72,50,76,59,93,61,59,80,68,62,78,56,52,96,82,83,99,73,100,91,58,70,76,52,99,66,73,75,98,74,92,54,57,60,59,91,74,78,76,59,59,75,89,65,53,97,97,95,57,92,100,76,90,64,83,83,77,81,76,92,81,85,83,70,92,87,91,89,79,96,55,79,81,90,79,66,59,67,75,97,54,66,61,80,61,86,88,75,56,65,85,72,50,53,82,71,72,59,50,72,67,90,72,51,70,68,62,90,63,65,70,67,60,75,58,54,94,82,75,74,56,87,50,84,100,98,80,67,95,97,69,70,69,70,88,81,58,70,86,76,67,77,94,73,57,81,84,74,98,69,57,57,57,89,51,81,92,97,100,99,93,82,92,65,94,58,92,69,60,51,81,78,54,60,82,80,66,70,83,86,78,77,90,65,54,80,99,54,79,94,85,56,83,55,53,80,97,87,71,100,84,92,63,95,92,97,99,77,99,82,85,98,57,69,68,71,97,56,57,80,52,72,74,68,68,93,94,64,57,77,56,82,98,95,67,66,54,70,68,72,85,62,55]
          //   // ],
          //   // "sample": 5, //default 5
          //   // "round": 4 // default 4
          // }),
          graphs.isScatterplot &&
            getScatterPlot({
              arr1: firstValue,
              arr2: secondValue,
              withReg: false,
            }),
        ]);
      }

      // firestore is not accepting array inside of arrays, so this will be converted to an object
      const [firstCorrCoef, secondCorrCoef] = corResult.correlation.corrcoef;
      corResult.correlation.corrcoef = { 0: firstCorrCoef, 1: secondCorrCoef };
      // console.log("corrCoef >>", corResult.correlation);

      const correlationResults = {
        ...corResult,
        ...scatterPlotResult,
        column: First + ", " + Second,
        graphs,
        Methods,
        title,
      };

      // return console.log("correlationResults :>> ", correlationResults);

      try {
        //update analysis subcollection
        const resFromCreateAnalysis = await createAnalysis(
          token,
          documentId,
          correlationResults
          // graphResult
        );
        correlationResults.id = resFromCreateAnalysis.id;
      } catch (error) {
        return console.log("error", error);
      }

      // corResult && dispatch(addAnalysisAndGraphs(resFromCreateAnalysis)); // add dispatch here
      dispatch(setIsLoading());
    } else {
      haveSameLength && closeMenu();
      dispatch(setIsLoading());
    }
  };

  return (
    <Modal
      open={openModal === title}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <h1> {title}</h1>
        <Grid
          item
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          style={{
            padding: "10px",
          }}
        >
          <Grid item xs={6} p={1}>
            <h3> Data Range</h3>
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Select 1st column for the test
            </h3>
            <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
              <InputLabel id="demo-simple-select-label">Column</InputLabel>
              <Dropdown value={First} onChange={onChangeFirstColumn} />
            </FormControl>
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Select 2nd column for the test
            </h3>
            <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
              <InputLabel id="demo-simple-select-label">Column</InputLabel>
              <Dropdown value={Second} onChange={onChangeSecondColumn} />
            </FormControl>
          </Grid>

          <Grid item xs={6} p={1}>
            <h3> Additional Options</h3>
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Confidence level
            </h3>
            <TextField
              fullWidth
              id="filled-basic"
              variant="filled"
              label="Type a number between 0 to 100.0"
              sx={{ mt: 1 }}
              defaultValue={95}
              type="number"
              onChange={(e) => handleChangeConfidenceLevel(e.target.value)}
            />
            <h3
              style={{
                marginTop: "13px",
              }}
            >
              Graphs
            </h3>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="Histogram"
                name="radio-buttons-group"
              >
                <FormControlLabel
                  value="Scatterplot"
                  control={
                    <Checkbox
                      onChange={handleGraphCBChange}
                      name="isScatterplot"
                    />
                  }
                  label="Scatterplot"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={6} p={1}>
            <h3> Correlation Methods</h3>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="Histogram"
                name="radio-buttons-group"
              >
                <FormControlLabel
                  value="Pearson's r"
                  control={
                    <Checkbox onChange={handleMethodsChange} name="isPearson" />
                  }
                  label="Pearson's r"
                />
                <FormControlLabel
                  value="Spearman's rho"
                  control={
                    <Checkbox
                      onChange={handleMethodsChange}
                      name="isSpearman"
                    />
                  }
                  label="Spearman's rho"
                />
                <FormControlLabel
                  value="Kendall's tau"
                  control={
                    <Checkbox onChange={handleMethodsChange} name="isKendall" />
                  }
                  label="Kendall's tau"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>

        <FunctionButtons
          handleCloseModal={handleCloseModal}
          error={error}
          computeTTest={computeTTest}
        />
      </Box>
    </Modal>
  );
};

export default CorrelationModal;
